var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loader-wrapper" }, [
      _c("img", {
        staticClass: "loader",
        attrs: { src: require("../assets/loading.svg"), alt: "Loading" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }